import { useRef, useState } from "react";
import {
  areSkillFormValuesDirty,
  getSkillFormValues,
  SkillFormMode,
  SkillFormValues,
} from "./SkillFormModal";

export const useSkillInlineFormState = () => {
  const [formMode, setFormMode] = useState<SkillFormMode | null>(null);
  const [formInitialValues, setFormInitialValues] =
    useState<Partial<SkillFormValues>>();
  const [formValues, setFormValues] = useState<SkillFormValues | null>(null);
  const [isDiscardConfirmOpen, setIsDiscardConfirmOpen] = useState(false);
  const pendingDiscardActionRef = useRef<(() => void) | null>(null);

  const isDirty =
    !!formMode &&
    !!formValues &&
    areSkillFormValuesDirty(formValues, formInitialValues);

  const beginForm = (
    mode: SkillFormMode,
    initialValues?: Partial<SkillFormValues>
  ) => {
    setFormMode(mode);
    setFormInitialValues(initialValues);
    setFormValues(getSkillFormValues(initialValues));
  };

  const closeForm = () => {
    setFormMode(null);
    setFormInitialValues(undefined);
    setFormValues(null);
  };

  const runAfterDiscardCheck = (action: () => void) => {
    if (!isDirty) {
      action();
      return;
    }

    pendingDiscardActionRef.current = action;
    setIsDiscardConfirmOpen(true);
  };

  const confirmDiscardChanges = () => {
    const action = pendingDiscardActionRef.current;
    pendingDiscardActionRef.current = null;
    setIsDiscardConfirmOpen(false);
    action?.();
  };

  const abortDiscardChanges = () => {
    pendingDiscardActionRef.current = null;
    setIsDiscardConfirmOpen(false);
  };

  return {
    formMode,
    formInitialValues,
    formValues,
    setFormValues,
    isDirty,
    isDiscardConfirmOpen,
    beginForm,
    closeForm,
    runAfterDiscardCheck,
    confirmDiscardChanges,
    abortDiscardChanges,
  };
};
